import { apiRoutesUrls } from "./ApiNames";
export const getDataApi = async (apiAddress, updatingFunction) => {
    try {
        const response = await fetch(`${apiRoutesUrls.main}${apiAddress.replace(/\s/g, "")}`);

        if (!response.ok) {
            window.location.href = window.location.origin + `/error`;
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const json = await response.json();
        updatingFunction(json);
    } catch (error) {
        console.error("Fetch error:", error);
    }
};

export const getDataApi2 = async (apiAddress, updatingFunction) => {
    try {
        const response = await fetch(`${apiRoutesUrls.main2}${apiAddress.replace(/\s/g, "")}`);

        if (!response.ok) {
            window.location.href = window.location.origin + `/error`;
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const json = await response.json();
        updatingFunction(json);
    } catch (error) {
        console.error("Fetch error:", error);
    }
};

    export const getDataApiMore = (apiAddress, updatingFunction, updateMore) => {
        fetch(`${apiRoutesUrls.main}${apiAddress.replace(/\s/g, "")}`)
            .then((res) => res.json())
            .then((json) => {
                updatingFunction(json);
                if(json.length < 20) {
                    updateMore(false)
                } else {
                    updateMore(true)
                }
            })
    };

    export const getDataCms = (apiAddress, updatingFunction) => {
        fetch(`${apiRoutesUrls.cms}${apiAddress.replace(/\s/g, "")}`)
            .then((res) => res.json())
            .then((json) => {
                updatingFunction(json);
            });
    };

    export const getCategoryImage = (apiAddress, updatingFunction) => {
        fetch(
            `${apiRoutesUrls.cmsCategoryArchivesImage}${apiAddress.replace(/\s/g,"")}`)
            .then((res) => res.json())
            .then((json) => {
                updatingFunction(json);
            });
    };